import * as tslib_1 from "tslib";
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
var Loader = /** @class */ (function (_super) {
    tslib_1.__extends(Loader, _super);
    function Loader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Loader.prototype.render = function () {
        return (React.createElement(LoaderWrapper, null,
            React.createElement(Container, null,
                React.createElement(LoadingCircle, { style: { animationDelay: "0s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "0.25s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "0.50s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "0.75s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "1s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "1.25s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "1.50s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "1.75s" } }),
                React.createElement(LoadingCircle, { style: { animationDelay: "2s" } }))));
    };
    ;
    return Loader;
}(React.Component));
export { Loader };
var Container = styled.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    bottom:20%;\n    width:100%;\n    display:flex;\n    justify-content: space-evenly;\n    position:absolute;\n    "], ["\n    bottom:20%;\n    width:100%;\n    display:flex;\n    justify-content: space-evenly;\n    position:absolute;\n    "])));
var move = keyframes(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  0% {\n    border: none;\n  }\n\n  50% {\n    border: #00A3FF solid 4px;\n  }\n\n  100% {\n    border: none;\n  }\n"], ["\n  0% {\n    border: none;\n  }\n\n  50% {\n    border: #00A3FF solid 4px;\n  }\n\n  100% {\n    border: none;\n  }\n"])));
var LoaderWrapper = styled.div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n    width:100%;\n    height:100%;\n    background-color:#00000085;\n    position:absolute;\n\n"], ["\n    width:100%;\n    height:100%;\n    background-color:#00000085;\n    position:absolute;\n\n"])));
var LoadingCircle = styled.div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n    animation: ", " 2s linear infinite;\n    animation-timing-function:step-start;\n    transform:translateY(90%);\n\n    width:2vh;\n    height:2vh;\n"], ["\n    animation: ", " 2s linear infinite;\n    animation-timing-function:step-start;\n    transform:translateY(90%);\n\n    width:2vh;\n    height:2vh;\n"])), move);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;



//////////////////
// WEBPACK FOOTER
// ./src/Components/Loader.tsx
// module id = 35
// module chunks = 0